import { Checkbox, ExpanderList } from "@rio-cloud/rio-uikit";
import Chip from "../Chip";
import { Driver } from "@types";
import Avatar from "../Avatar/indext";

interface Props {
  data: Array<Driver>;
  selected: string[];
  onClickButton: (
    type: "CALENDAR" | "PROFILE" | "VEHICLE",
    id?: string,
    data?: Driver
  ) => void;
  onChecked: (
    checked: boolean,
    id: string,
    name: string,
    userId?: string,
    avatar?: string,
    uniqueProfileId?: string,
  ) => void;
}

const ExpanderListDriver = ({
  data,
  onClickButton,
  onChecked,
  selected,
}: Props) => {
  const renderHeader = ({ name, userId, id, type, avatar, uniqueProfileId }: Driver) => {
    const disabled = uniqueProfileId ? false : !userId;

    return (
      <div className="display-flex align-items-center gap-20">
        <fieldset className="margin-bottom-10">
          <Checkbox
            disabled={disabled}
            checked={selected.includes(id) || (!!userId && selected.includes(userId))}
            onChange={(event) =>
              onChecked(event.target.checked, id, name as string, userId, avatar, uniqueProfileId)
            }
          />
        </fieldset>
        <div className="display-flex align-items-center gap-10">
          <Avatar url={avatar} />

          <div className="display-flex flex-column gap-2">
            <span className="text-size-16 text-normal line-height-20 text-capitalize">
              {name}
            </span>

            <div className="display-flex gap-2">
              {type === 'MANAGER' ? (
                <Chip
                  text="Gestor da frota"
                  icon="rioglyph rioglyph-role-management"
                  background="bg-black"
                />
              ) : (
                <Chip
                  text="Minha equipe"
                  icon="rioglyph rioglyph-role-management"
                  background="bg-status-working"
                  disabled={type === 'CONNECTED' ? true : !userId}
                />
              )}

              <Chip
                text="Trucker assist"
                icon="rioglyph rioglyph rioglyph-phone"
                background="bg-status-driving"
                disabled={!uniqueProfileId}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderBody = (d: Driver) => {
    return (
      <div className="display-flex align-items-center gap-20">
        <button
          type="button"
          className="btn btn-default width-150"
          onClick={() => onClickButton("PROFILE", d.userId, d)}
        >
          <span className="rioglyph rioglyph-user" aria-hidden="true"></span>
          <span>Ver perfil</span>
        </button>
      </div>
    );
  };

  return (
    <ExpanderList
      unmountOnExit
      items={data.map((driver, index) => {
        return {
          id: index,
          header: renderHeader(driver),
          body: driver.isEnabled ? renderBody(driver) : null,
          bodyClassName: "margin-bottom-20",
        };
      })}
      bordered={true}
      rounded={false}
    />
  );
};

export default ExpanderListDriver;
